module.exports = __webpack_public_path__ + "img/108.2.e1d0256e.png";